"use client";
import { Toast } from "primereact/toast";
import React, { createContext, useContext, useRef } from "react";
import styles from "./toast.module.scss";

export const ToastContext = createContext({});

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};

export const ToastProvider = ({ children }: any) => {
  const toastRef = useRef<any>(null);

  function showSuccess(summary: string, detail: string) {
    toastRef?.current?.clear();
    toastRef?.current?.show({
      severity: "success",
      summary: summary,
      detail
    });
  }

  function showError(summary: string, detail: string) {
    toastRef?.current?.clear();
    toastRef?.current?.show({
      severity: "error",
      summary: summary,
      detail: detail
    });
  }

  function showInfo(summary: string, detail: string) {
    toastRef?.current?.clear();
    toastRef?.current?.show({
      severity: "info",
      summary: "Info",
      detail: detail
    });
  }

  return (
    <ToastContext.Provider value={{ showSuccess, showError, showInfo }}>
      {children}
      <Toast
        ref={toastRef}
        className={styles.toastMessage}
        position="top-right"
      />
    </ToastContext.Provider>
  );
};
